// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"30b06190","186":"462ba0e7","193":"8110b93c","403":"15a01171"}[chunkId] + ".chunk.css";
};